import am5geodata_usaLow from "@amcharts/amcharts5-geodata/usaLow";
import type { FeatureCollection } from "geojson";

import { getDmaLabelMap } from "@/helpers/dimensionLabels";
import { MapGeography, mapGeography } from "@/settings/charts/mapGeography";
import { ChartDataRecord } from "@/types/charts";
import { InputDictionary } from "@/types/common";

export const buildMapDisplayNameMap = (geography: MapGeography): Record<string, string> => {
  if (geography !== mapGeography.states) {
    return getDmaLabelMap();
  }

  const map: Record<string, string> = {};
  for (const feature of (am5geodata_usaLow as unknown as FeatureCollection).features) {
    const props = (feature.properties ?? {}) as Record<string, unknown>;
    const id = (feature.id ?? props.id) as string | undefined;
    const name = props.name as string | undefined;
    if (id && name) map[id] = name;
  }

  return map;
};

export const prepareMapDataForExport = (
  responseData: ChartDataRecord[],
  geography: MapGeography,
  metricsDictionary: InputDictionary[]
): Record<string, unknown>[] => {
  const labelMap = buildMapDisplayNameMap(geography);
  const dimensionField = geography as string;

  return responseData.map((item: Record<string, unknown>) => {
    return Object.keys(item).reduce((acc, key) => {
      if (key === dimensionField) {
        const raw = item[key];
        return { ...acc, [key]: typeof raw === "string" ? labelMap[raw] ?? raw : raw };
      }

      const value = item[key];
      if (value === null || value === undefined) {
        return { ...acc, [key]: 0 };
      }

      const formatter = metricsDictionary.find((metric) => metric.value === key)?.formatter;
      return { ...acc, [key]: formatter && typeof value === "string" ? formatter(value) : value };
    }, {});
  });
};
